import { AlertTriangle, Loader2 } from 'lucide-react';
import {
  ResumeCard,
  ResumeCardHeader,
} from '@/components/commercial/proposals/shared/summary-components';
import { cn } from '@/lib/utils';

interface ContractErrorStateProps {
  message?: string;
  isRetrying?: boolean;
  onRetry?: () => void;
}

export function ContractErrorState({ message, isRetrying, onRetry }: ContractErrorStateProps) {
  return (
    <ResumeCard>
      <ResumeCardHeader
        title="Assinatura eletrônica do contrato"
        icon={<AlertTriangle className="h-4 w-4 text-red-500" />}
      />
      <div className="space-y-4 px-5 py-5">
        <div className="flex items-start gap-3">
          <div className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-red-50">
            <AlertTriangle className="h-5 w-5 text-red-600" aria-hidden="true" />
          </div>
          <div className="min-w-0 space-y-1">
            <p className="text-sm font-semibold text-gray-900">
              Não foi possível concluir a assinatura
            </p>
            <p className="text-xs text-gray-500">
              {message ?? 'Ocorreu um erro no processo de assinatura. Tente novamente.'}
            </p>
          </div>
        </div>

        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            disabled={isRetrying}
            className={cn(
              'inline-flex h-11 w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-6 text-sm font-semibold text-white transition-colors hover:bg-blue-700',
              'disabled:cursor-not-allowed disabled:opacity-60',
            )}
          >
            {isRetrying && <Loader2 className="h-4 w-4 animate-spin" />}
            {isRetrying ? 'Tentando novamente...' : 'Tentar novamente'}
          </button>
        )}
      </div>
    </ResumeCard>
  );
}
